"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StarFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function StarFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "icon"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Associations"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "star-fill"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-2",
    "data-name": "outline",
    d: "M25.278,90.542a2.5,2.5,0,0,1-2.464-2.923l4.5-26.231L8.255,42.809a2.5,2.5,0,0,1,1.386-4.263l26.338-3.828L47.758,10.851a2.5,2.5,0,0,1,4.484,0L64.021,34.718l26.338,3.828a2.5,2.5,0,0,1,1.386,4.263L72.687,61.388l4.5,26.231a2.5,2.5,0,0,1-3.627,2.636L50,77.87,26.441,90.255A2.5,2.5,0,0,1,25.278,90.542Z"
  }))));
}